<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- tabla de datos -->
    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <v-card>
        <v-card-title class="text-h5 font-weight-bold primary--text">
          <v-row>
            <v-col cols="2" sm="8">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs"
                    v-on="on"
                    @click="regresar"
                  >
                    <v-icon> mdi-arrow-left </v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>
              Gestionar Participantes
            </v-col>

            <v-col cols="12" sm="4">
              <div class="d-flex align-center">
                <v-text-field
                  outlined
                  dense
                  append-icon="mdi-magnify"
                  label="Buscar Participante"
                  hide-details
                  class="mr-4"
                  v-model="searchTable"
                >
                </v-text-field>
                <v-btn exact color="primary" @click="open"> Registrar </v-btn>
              </div>
            </v-col>
            <v-col cols="5" offset-sm="1" sm="2">
              <p class="text-subtitle-1 font-weight-bold primary--text">
                Cupos Asignados: {{ cupoSaber.numero_participantes }}
              </p>
            </v-col>

            <v-col cols="5" sm="2">
              <p
                :class="[
                  'text-subtitle-1',
                  'font-weight-bold',
                  { 'error--text': cupoDisponible == 0 },
                ]"
              >
                Disponibles: {{ cupoDisponible }}
              </p>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          fixed-header
          height="calc(100vh - 280px)"
          class="elevation-2"
          :headers="headersTable"
          :items="participantes"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
        
        <template v-slot:[`item.acciones`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                color="primary"
                v-bind="attrs"
                class="mr-2"
                v-on="on"
                @click="detalles(item.id)"
              >
                mdi-eye
              </v-icon>
            </template>
            <span>Detalles</span>
          </v-tooltip>
        
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                @click="editar(item.id)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Actualizar</span>
          </v-tooltip>
        
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                color="error"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                @click="activarAlertaEliminar(item.id)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
          <template v-slot:top>
            <v-dialog
              persistent
              scrollable
              max-width="520px"
              v-model="dialogForm"
            >
              <v-card :loading="loadingForm">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">
                    {{ formTitle }}
                  </p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="10">
                        <v-form ref="form" v-model="form">
                          <!-- Campos bloqueados -->
                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Competencia"
                            v-model="competenciaSeleccionada"
                          ></v-text-field>

                          <!--Saber y Modalidad -->
                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Saber"
                            v-model="saberSeleccionado"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Modalidad"
                            v-model="modalidadSeleccionada"
                          ></v-text-field>

                          <!-- Programa de Formación -->
                          <v-autocomplete
                            outlined
                            dense
                            label="Programa de Formación*"
                            :items="programasFormacion"
                            item-value="id"
                            item-text="programa_formacion"
                            v-model="programaFormacion"
                            :rules="programaFormacionReglas"
                          ></v-autocomplete>

                          <!-- Ficha -->
                          <v-text-field
                            outlined
                            dense
                            type="number"
                            maxlength="10"
                            counter
                            label="Número de Ficha"
                            :rules="numeroFichaReglas"
                            v-model="numeroFicha"
                          ></v-text-field>

                          <!-- Tipo y número de identificación -->
                          <v-select
                            outlined
                            dense
                            label="Tipo de Identificación*"
                            :items="tiposIdentificacion"
                            item-value="id"
                            item-text="tipo_identificacion"
                            v-model="tipoIdentificacion"
                            :rules="tipoIdentificacionReglas"
                          ></v-select>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Número de Identificación*"
                            v-model="identificacion"
                            :rules="identificacionReglas"
                          ></v-text-field>

                          <!-- Datos personales -->
                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Nombres*"
                            v-model="nombres"
                            :rules="nombresReglas"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Apellidos*"
                            v-model="apellidos"
                            :rules="apellidosReglas"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Correo Electrónico*"
                            maxlength="50"
                            counter
                            v-model="correo"
                            :rules="correoReglas"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Teléfono Móvil*"
                            maxlength="10"
                            counter
                            v-model="telefonoMovil"
                            :rules="telefonoMovilReglas"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Dirección*"
                            maxlength="50"
                            counter
                            v-model="direccion"
                            :rules="direccionReglas"
                          ></v-text-field>

                          <!-- Fecha de nacimiento -->
                          <v-dialog
                            ref="fechaNacimiento"
                            persistent
                            width="300px"
                            v-model="dialogFechaNacimiento"
                            :return-value.sync="fechaNacimiento"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                outlined
                                dense
                                readonly
                                prepend-inner-icon="mdi-calendar"
                                label="Fecha de Nacimiento*"
                                v-model="fechaNacimiento"
                                :rules="fechaNacimientoReglas"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>

                            <v-date-picker
                              scrollable
                              locale="es"
                              color="primary"
                              v-model="fechaNacimiento"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="error"
                                @click="dialogFechaNacimiento = false"
                                >Cancelar</v-btn
                              >
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.fechaNacimiento.save(fechaNacimiento)
                                "
                                >OK</v-btn
                              >
                            </v-date-picker>
                          </v-dialog>

                          <!-- Género -->
                          <v-select
                            outlined
                            dense
                            label="Género*"
                            :items="generos"
                            item-value="id"
                            item-text="genero"
                            v-model="genero"
                            :rules="generoReglas"
                          ></v-select>

                          <!-- estados civiles -->
                          <v-select
                            outlined
                            dense
                            label="Estado Civil*"
                            :items="estadosCiviles"
                            item-value="id"
                            item-text="estado_civil"
                            v-model="estadoCivil"
                            :rules="estadoCivilReglas"
                          ></v-select>

                          <!-- estrato -->
                          <v-select
                            outlined
                            dense
                            label="Estrato*"
                            :items="estratos"
                            item-value="id"
                            item-text="estrato"
                            v-model="estrato"
                            :rules="estratoReglas"
                          ></v-select>

                          <!-- zona -->
                          <v-select
                            outlined
                            dense
                            label="Zona*"
                            :items="zonas"
                            item-value="id"
                            item-text="zona"
                            v-model="zona"
                            :rules="zonaReglas"
                          ></v-select>

                          <!-- discapacidad -->
                          <v-select
                            outlined
                            dense
                            label="Discapacidad*"
                            :items="discapacidades"
                            item-value="id"
                            item-text="discapacidad"
                            v-model="discapacidad"
                            :rules="discapacidadReglas"
                          ></v-select>

                          <!--Tipo de Alimentación -->
                          <v-select
                            outlined
                            dense
                            label="Tipo de Alimentación*"
                            :items="tipoAlimentacion"
                            item-value="id"
                            item-text="tipo_alimentacion"
                            v-model="tiposAlimentacion"
                            :rules="tipoAlimentacionReglas"
                          ></v-select>

                          <!-- Restricción alimentaria -->
                          <v-select
                            outlined
                            dense
                            label="¿Tiene restricción alimentaria?"
                            :items="restriccionesAlimentarias"
                            item-value="valor"
                            item-text="texto"
                            v-model="restriccionAlimentaria"
                            :reglas="restriccionAlimentariaReglas"
                          ></v-select>

                          <v-text-field
                            v-if="restriccionAlimentaria"
                            outlined
                            dense
                            label="Descripción restricción alimentaria"
                            v-model="descripcionRestriccionAlimentaria"
                          ></v-text-field>

                          <!-- Enfermedad existente -->
                          <v-select
                            outlined
                            dense
                            label="¿Tiene alguna enfermedad existente?"
                            :items="enfermedadesExistentes"
                            item-value="valor"
                            item-text="texto"
                            v-model="enfermedadExistente"
                            :reglas="enfermedadExistenteReglas"
                          ></v-select>

                          <v-text-field
                            v-if="enfermedadExistente"
                            outlined
                            dense
                            label="Descripción enfermedad existente"
                            v-model="descripcionEnfermedadExistente"
                          ></v-text-field>

                          <!-- talla camiseta -->
                          <v-select
                            outlined
                            dense
                            label="Talla de Camiseta*"
                            :items="tallas"
                            v-model="talla"
                            :rules="tallaReglas"
                          ></v-select>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="close"> Cancelar </v-btn>

                  <template v-if="editedIndex === -1">
                    <v-btn text exact color="primary" @click="registrar">
                      Registrar
                    </v-btn>
                  </template>

                  <template v-else>
                    <v-btn text exact color="primary" @click="actualizar">
                      Actualizar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>

        </v-data-table>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="justify-center text-h6">
              ¿Desea eliminar el participante?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="error" @click="closeDelete"> Cancelar </v-btn>
              <v-btn text color="primary" @click="eliminar()"> OK </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </template>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";

export default {
  data: () => ({
    alert: false,
    alertType: "",
    alertTitle: "",
    alertMessage: "",

    skeletonLoader: true,
    searchTable: null,

    loadingForm: false,
    form: true,

    dialogForm: false,
    dialogDelete: false,

    headersTable: [
      {
        text: "Identificación",
        value: "identificacion",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },
    
      {
        text: "Nombres",
        value: "nombres",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },
    
      {
        text: "Apellidos",
        value: "apellidos",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },
    
      {
        text: "Correo Electrónico",
        value: "correo",
        align: "start",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    
      {
        text: "Saber",
        value: "saber",
        width: "30%",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },
    
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],

    competenciaSeleccionada: "",
    saberSeleccionado: "",
    modalidadSeleccionada: "",
    centroFormacionId: null,
    cupoAsignado: null,
    participanteId: null,

    descripcionEnfermedadExistente: null,
    enfermedadExistente: null,
    enfermedadExistenteReglas: [(v) => !!v || "Seleccione una valor"],
    enfermedadesExistentes: [
      { texto: "Sí", valor: true },
      { texto: "No", valor: false },
    ],

    descripcionRestriccionAlimentaria: null,
    restriccionAlimentaria: null,
    restriccionAlimentariaReglas: [(v) => !!v || "Seleccione una valor"],
    restriccionesAlimentarias: [
      { texto: "Sí", valor: true },
      { texto: "No", valor: false },
    ],

    alertParticipante: false,

    categoria: null,
    categoriaReglas: [(v) => !!v || "Seleccione una categoria"],

    programaFormacion: null,
    programaFormacionReglas: [
      (v) => !!v || "Seleccione un programa de formación",
    ],

    numeroFicha: null,
    numeroFichaReglas: [
      (v) => !!v || "Escriba un número de ficha",
      (v) => v > 0 || "No puede ser un número menor a 0",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos",
    ],

    tipoIdentificacion: null,
    tipoIdentificacionReglas: [
      (v) => !!v || "Seleccione un tipo de Identififcacion",
    ],
    
    tiposIdentificacion: [
      { tipo_identificacion: "Tarjeta de Identidad", id: 1 },
      { tipo_identificacion: "Cedula de Ciudadania", id: 2 },
      { tipo_identificacion: "Documento Extranjero", id: 3 },
    ],

    identificacion: null,
    identificacionReglas: [
      (v) => !!v || "Escriba un número de identificación",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos",
      (v) => (v && v.length >= 6) || "Minimo 6 digitos",
    ],
    mensajeIdentificacion: "",

    nombres: null,
    nombresReglas: [(v) => !!v || "Escriba los nombres"],

    apellidos: null,
    apellidosReglas: [(v) => !!v || "Escriba los apellidos"],

    correo: null,
    correoReglas: [
      (v) => !!v || "Escriba un correo electrónico",
      (v) => /.+@.+\..+/.test(v) || "Correo electrónico no válido",
    ],

    telefonoMovil: null,
    telefonoMovilReglas: [
      (v) => !!v || "Escriba un número de telefono movil",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos",
    ],

    direccion: null,
    direccionReglas: [(v) => !!v || "Escriba una dirección"],

    dialogFechaNacimiento: false,
    fechaNacimiento: null,
    fechaNacimientoReglas: [(v) => !!v || "Seleccione una fecha"],

    genero: null,
    generoReglas: [(v) => !!v || "Seleccione un genero"],
    generos: [
      { genero: "Femenino", id: 1 },
      { genero: "Masculino", id: 2 },
      { genero: "No Binario", id: 3 },
    ],

    estadoCivil: null,
    estadoCivilReglas: [(v) => !!v || "Seleccione un estado civil"],

    estrato: null,
    estratoReglas: [(v) => !!v || "Seleccione un estrato"],
    estratos: [
      { estrato: 1, id: 1 },
      { estrato: 2, id: 2 },
      { estrato: 3, id: 3 },
      { estrato: 4, id: 4 },
      { estrato: 5, id: 5 },
      { estrato: 6, id: 6 },
    ],

    zona: null,
    zonaReglas: [(v) => !!v || "Seleccione una zona"],
    zonas: [
      { zona: "Urbana", id: 1 },
      { zona: "Rural", id: 2 },
    ],

    tiposAlimentacion: null,
    tipoAlimentacionReglas: [
      (v) => !!v || "Seleccione un tipo de alimentación",
    ],

    discapacidad: null,
    discapacidadReglas: [(v) => !!v || "Seleccione una discapacidad"],

    talla: null,
    tallas: ["XS", "S", "M", "L", "XL", "XXL", "3XL"],
    tallaReglas: [(v) => !!v || "Seleccione una talla"],

      idPersona: null,
    idParticipante: null,

    

    editedIndex: -1,
  }),

  components: {
    Alert,
  },

  mounted() {
    this.$store.dispatch("crearProgramasFormacion");
    this.$store.dispatch("crearEstadosCiviles");
    this.$store.dispatch("crearDiscapacidades");
    this.$store.dispatch("crearTipoAlimentacion");
    this.$store.dispatch("gestionarCuposCampesena", this.$route.params.idCompetencia);
    this.$store.dispatch("gestionarParticipantesCampesena",this.$route.params.idCompetencia);
    this.$store.dispatch("obtenerSaberCompetenciaId", {
      idCompetencia: this.$route.params.idCompetencia,
      idSaber: this.$route.params.idSaber,
    });
 
    setTimeout(() => {
      this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Registrar Participante"
        : "Actualizar Participante";
    },

    usuario() {
      return this.$store.getters.usuario;
    },

    estadosCiviles() {
      return this.$store.getters.obtenerEstadosCiviles;
    },

    discapacidades() {
      return this.$store.getters.obtenerDiscapacidades;
    },

    programasFormacion() {
      return this.$store.getters.obtenerProgramasFormacion;
    },

    tipoAlimentacion() {
      return this.$store.getters.obtenerTipoAlimentacion;
    },

    participantes() {
      return this.$store.getters.obtenerParticipantesCentroFormacionCampesena( this.$route.params.idSaber,this.usuario.centro_formacion_id
      );
    },

    cupoSaber() {
      return this.$store.getters.obtenerCupoAsignadoSaberCampesena(this.usuario.centro_formacion_id, this.$route.params.idSaber);
    },
    cupoDisponible() {
      return this.cupoSaber.numero_participantes - this.participantes.length;
    },
    participante() {
      return this.$store.getters.obtenerParticipanteCampesena;
    },
    saberCompetencia() {
      return this.$store.getters.obtenerSaberCompetencia;
    },
  },

  watch: {
    dialogForm(val) {
      val || this.close();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    open() {
      this.dialogForm = true;
      this.competenciaSeleccionada = this.saberCompetencia.competencia
      this.saberSeleccionado = this.saberCompetencia.saber
      this.modalidadSeleccionada = this.saberCompetencia.modalidad;      
    },

    close() {
      this.$refs.form.reset();
      this.dialogForm = false;
      this.editedIndex = -1;
    },

 
    registrar() {
      if (this.$refs.form.validate()) {
        const nombresPersona = this.nombres.trim().split(" ");
        const apellidosPersona = this.apellidos.trim().split(" ");

        const participante = {
          competencia_id: this.$route.params.idCompetencia,
          saber_id: this.$route.params.idSaber,
          centro_formacion_id: this.usuario.centro_formacion_id,
          programa_formacion_id: this.programaFormacion,
          numero_ficha: this.numeroFicha,
          talla_camiseta: this.talla,
          tipo_identificacion_id: this.tipoIdentificacion,
          identificacion: this.identificacion,
          primer_nombre: nombresPersona[0],
          segundo_nombre: nombresPersona[1],
          primer_apellido: apellidosPersona[0],
          segundo_apellido: apellidosPersona[1],
          correo: this.correo,
          telefono_movil: this.telefonoMovil,
          direccion: this.direccion,
          fecha_nacimiento: this.fechaNacimiento,
          edad: Math.floor(
            (new Date() - new Date(this.fechaNacimiento)) /
              (365.25 * 24 * 60 * 60 * 1000)
          ),
          genero_id: this.genero,
          estado_civil_id: this.estadoCivil,
          estrato: this.estrato,
          zona_id: this.zona,
          discapacidad_id: this.discapacidad,
          tipo_alimentacion_id: this.tiposAlimentacion,
          restriccion_alimentaria: this.restriccionAlimentaria,
          descripcion_restriccion_alimentaria:
            this.descripcionRestriccionAlimentaria,
          enfermedad_existente: this.enfermedadExistente,
          descripcion_enfermedad_existente: this.descripcionEnfermedadExistente,
        };

        this.loadingForm = true;

        this.$store
          .dispatch("registrarParticipanteCampesena", participante)
          .then((response) => {
            if (response.status == "success") {
              let message = response.message.split(",");
              this.loadingForm = false;
              this.alertTitle = message[0];
              this.alertMessage = message[1];
              this.alertType = "success--text";
              this.alert = true;

              this.skeletonLoader = true;

              this.$store.dispatch(
                "gestionarParticipantesCampesena",
                this.$route.params.idCompetencia
              );

              this.close();

              setTimeout(() => {
                this.alert = false;
                this.skeletonLoader = false;
              }, 2000);
            } else {
              this.loadingForm = false;
              this.alert = true;
              this.alertTitle = "Error";
              this.alertType = "error--text";
              for (const error in response.message) {
                this.alertMessage = response.message[error][0];
              }
            }

            setTimeout(() => {
              this.alert = false;
            }, 3000);
          })
          .catch(() => {});
      }
    },

    detalles(idParticipante) {
      this.$router.push({
        name: "campesena-competencia-participantes-detalle",
        params: { idParticipante: idParticipante },
      });
    },

    editar(idParticipante) {
      this.dialogForm = true;
      this.editedIndex = 1;
      this.participanteId = idParticipante;
      this.competenciaSeleccionada = this.saberCompetencia.competencia
      this.saberSeleccionado = this.saberCompetencia.saber
      this.modalidadSeleccionada = this.saberCompetencia.modalidad;   
      this.$store.dispatch("obtenerParticipanteCampesenaId", idParticipante);
      setTimeout(() => {
        const response = this.participante;
        this.centroFormacionId = response.centro_formacion_id;
        this.programaFormacion = response.programa_formacion_id;
        this.numeroFicha = response.numero_ficha;
        this.talla = response.talla_camiseta;
        this.tipoIdentificacion = response.tipo_identificacion_id;
        this.identificacion = response.identificacion;
        this.nombres = response.nombres;
        this.apellidos = response.apellidos;
        this.correo = response.correo;
        this.telefonoMovil = response.telefono_movil;
        this.direccion = response.direccion;
        this.fechaNacimiento = response.fecha_nacimiento;
        this.edad = response.edad;
        this.genero = response.genero;
        this.estadoCivil = response.estado_civil;
        this.estrato = response.estrato;
        this.zona = response.zona;
        this.discapacidad = response.discapacidad;
        this.tiposAlimentacion = response.tipo_alimentacion;
        this.restriccionAlimentaria = response.restriccion_alimentaria;
        this.descripcionRestriccionAlimentaria = response.descripcion_restriccion_alimentaria;
        this.enfermedadExistente = response.enfermedad_existente;
        this.descripcionEnfermedadExistente =response.descripcion_enfermedad_existente;
      }, 1000);
    },

    actualizar() {
      if (this.$refs.form.validate()) {
        const nombresPersona = this.nombres.trim().split(" ");
        const apellidosPersona = this.apellidos.trim().split(" ");

        const participante = {
          competencia_id:this.$route.params.idCompetencia,
          saber_id: this.$route.params.idSaber,
          centro_formacion_id: this.usuario.centro_formacion_id,
          programa_formacion_id: this.programaFormacion,
          numero_ficha: this.numeroFicha,
          talla_camiseta: this.talla,
          tipo_identificacion_id: this.tipoIdentificacion,
          identificacion: this.identificacion,
          primer_nombre: (nombresPersona[0] || "").toLowerCase(),
          segundo_nombre: (nombresPersona[1] || "").toLowerCase(),
          primer_apellido: (apellidosPersona[0] || "").toLowerCase(),
          segundo_apellido: (apellidosPersona[1] || "").toLowerCase(),
          correo: this.correo,
          telefono_movil: this.telefonoMovil,
          direccion: this.direccion,
          fecha_nacimiento: this.fechaNacimiento,
          edad: Math.floor(
            (new Date() - new Date(this.fechaNacimiento)) /
              (365.25 * 24 * 60 * 60 * 1000)
          ),
          genero_id: this.genero,
          estado_civil_id: this.estadoCivil,
          estrato: this.estrato,
          zona_id: this.zona,
          discapacidad_id: this.discapacidad,
          tipo_alimentacion_id: this.tiposAlimentacion,
          restriccion_alimentaria: this.restriccionAlimentaria,
          descripcion_restriccion_alimentaria:
            this.descripcionRestriccionAlimentaria,
          enfermedad_existente: this.enfermedadExistente,
          descripcion_enfermedad_existente: this.descripcionEnfermedadExistente,
        };
        this.loadingForm = true;

        this.$store
          .dispatch("actualizarParticipanteCampesena", {
            participanteId: this.participanteId,
            participante: participante,
          })
          .then((response) => {
            if (response.status == "success") {
              this.close();
              this.loadingForm = false;
              const message = response.message.split(",");
              this.alertType = "success--text";
              this.alertTitle = message[0];
              this.alertMessage = message[1];
              this.alert = true;

              this.skeletonLoader = true;
              this.$store.dispatch(
                "gestionarParticipantesCampesena",
                this.$route.params.idCompetencia
              );

              setTimeout(() => {
                this.alert = false;
                this.skeletonLoader = false;
              }, 1000);
            } else {
              this.loadingForm = false;
              this.alertType = "error--text";
              this.alertTitle = "Error";

              for (const error in response.message) {
                this.alertMessage = response.message[error][0];
              }

              this.alert = true;

              setTimeout(() => {
                this.alert = false;
              }, 3000);
            }
          })
          .catch(() => {});
      }
    },

    activarAlertaEliminar(participante) {
      this.participanteId = participante;
      this.dialogDelete = true;
    },

    eliminar() {
      this.dialogDelete = false;

      this.$store
        .dispatch("eliminarParticipantesCampesena", this.participanteId)
        .then((response) => {
          if (response.status == "success") {
            let message = response.message.split(",");
            this.alert = true;
            this.alertTitle = message[0];
            this.alertMessage = message[1];
            this.alertType = "success--text";

            this.skeletonLoader = true;

            this.$store.dispatch(
              "gestionarParticipantesCampesena",
              this.$route.params.idCompetencia
            );

            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false;
            }, 2000);
          } else {
            this.loadingForm = false;
            this.alertType = "error--text";
            this.alertTitle = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0];
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false;
            }, 3000);
          }
        })
        .catch(() => {});
    },

    closeDelete() {
      this.dialogDelete = false;
      this.editedIndex = -1;
    },

    regresar() {
      this.$router.back();
    },
  },
};
</script>
